import { ChurnZeroEventName } from 'api/Api.generated';
import React, { useCallback } from 'react';
import { FooterWrapper, FooterLink, P, TinyP } from 'styles';

interface DefaultFooterProps {
  helpPhone?: string;
  helpEmail?: string;
  footerNote?: string;
  wide?: boolean;
  sendEvent?: (eventName: ChurnZeroEventName, token: string | null) => void;
}

export const DefaultFooter: React.FC<DefaultFooterProps> = ({
  helpPhone,
  helpEmail,
  footerNote,
  wide = false,
  sendEvent,
}) => {
  const onClick = useCallback(() => {
    sendEvent?.(ChurnZeroEventName.AlfiepayCallSupport, null);
  }, [sendEvent]);

  if (!helpPhone && !helpEmail) {
    return (
      <FooterWrapper wide={wide}>
        <P>{' '}</P>
        {footerNote && <TinyP>{footerNote}</TinyP>}
      </FooterWrapper>
    );
  }

  return (
    <FooterWrapper wide={wide}>
      <P>
        {helpPhone && (
          <>
            Call <FooterLink onClick={onClick} href={`tel:${helpPhone}`}>{helpPhone}</FooterLink>{' '}
          </>
        )}
        {helpEmail && (
          <>
            {helpPhone ? 'or email ' : 'Email '}
            <FooterLink onClick={onClick} href={`mailto:${helpEmail}`}>{helpEmail}</FooterLink>{' '}
          </>
        )}
        for more information and assistance.
      </P>
      {footerNote && <TinyP>{footerNote}</TinyP>}
    </FooterWrapper>
  );
};
